import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';

@Component({
    selector: 'main-profile-change-password',
    template: require('./profile-change-password.component.html')    
})

export class MainProfileChangePasswordComponent implements OnInit {
                
    @Input('isWrongPassword') wrongPassword: boolean;
    @Input('isOldPasswordEmpty') oldPasswordEmpty: boolean;
    @Input('isNewPasswordEmptyOrShort') newPasswordEmptyOrShort: boolean;
    @Output() oldUserPassword = new EventEmitter();
    @Output() newUserPassword = new EventEmitter();
    newPasswordType: String;    
    actualPassword: String;
    newPassword: String;    

    constructor() {        
        this.newPasswordType = "password";
        this.actualPassword = "";
        this.newPassword = "";
    }

    ngOnInit() {        

    }

    ngDoCheck() {
        this.oldUserPassword.emit ({
            value: this.actualPassword
        })
        this.newUserPassword.emit ({
            value: this.newPassword
        })
    }   

    onChangeNew(flag: any) {
        if (!flag) {
            this.newPasswordType = "password";
        } else {
            this.newPasswordType = "text";
        }
    }

    goBack() {
        window.history.back();
    }    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/profile/profile_change_password/profile-change-password.component.ts
 **/